import { css } from '@emotion/css';

export const focusBoxShadow = css`
  box-shadow: 0 0 1px 2px rgba(67, 132, 245, 0.7);
`;
